// возвращает массив из массивов длиной chunkSize
import type {
  IGetArraySplitIntoChunks,
  IGetUniqueArrayByProp,
  IShuffleArray,
} from '~/types/utils/arrays';
import type { TStringAnyObject } from '~/types/common';

/**
 * Разделяет массив на чанки и возвращает массив этих чанков
 * @param array - входящий массив
 * @param chunkSize - кол-во элементов в чанке
 * @returns массив с чанками
 */
export const getArraySplitIntoChunks: IGetArraySplitIntoChunks = (
  array: Array<any>,
  chunkSize: number = 10,
) => {
  return array.reduce((result: Array<any>, item: any, index: number) => {
    if (index % chunkSize) {
      result[result.length - 1].push(item);
    } else {
      result.push([item]);
    }
    return result;
  }, []);
};

export const getUniqueArrayByProp: IGetUniqueArrayByProp = (myArr, prop) => {
  return myArr.filter(
    (obj: TStringAnyObject, pos: number, arr: TStringAnyObject[]) =>
      arr.map((mapObj: TStringAnyObject) => mapObj[prop]).indexOf(obj[prop]) === pos,
  );
};

export const getUniqueListBy = (arr: Array<any>, key: string): Array<any> => [
  ...new Map(arr.map((item: any) => [item[key], item])).values(),
];

// https://learn.javascript.ru/task/shuffle
export const shuffleArray: IShuffleArray = (array) => {
  const newArr = [...array];
  for (let i = newArr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // случайный индекс от 0 до i
    [newArr[i], newArr[j]] = [newArr[j], newArr[i]];
  }
  return newArr;
};
